import React from "react";
import { Link } from "react-router-dom";
import Hero from "../../components/Hero/Hero";
import PageFooter from "../../components/PageFooter/PageFooter";
import "./home.css";
import Seo from "../../i18n/Seo";
import useLang from "../../i18n/useLang";
import { isLive, pathFor } from "../../i18n/routes";
import { demoUrl } from "../../i18n/links";
import content from "./content";

const TOOLS = [
  { routeId: "gbpAudit", icon: "📊", isNew: false },
  { routeId: "storeLocatorAudit", icon: "🏪", isNew: true },
  { routeId: "localSerpChecker", icon: "📍", isNew: false },
  { routeId: "reviewSentimentAnalysis", icon: "💬", isNew: true },
  { routeId: "reviewCalculator", icon: "⭐", isNew: true },
  { routeId: "schemaGenerator", icon: "🔧", isNew: false },
  { routeId: "gbpCategories", icon: "🏷️", isNew: true },
];

// Internal tool, shown with ?access=localranker.
const ADVANCED_SEARCH = { routeId: "advancedSearch", icon: "🔍", isNew: false };

const ToolCard = ({ tool, lang, t }) => {
  const { title, description } = t.tools[tool.routeId];
  return (
    <Link to={pathFor(tool.routeId, lang)}>
      <div className="tool-card">
        <div className="tool-card__icon">{tool.icon}</div>
        <div className="tool-card__body">
          <div className="tool-card__header">
            <h3 className="tool-card__title">{title}</h3>
            {tool.isNew && <span className="tool-card__tag">{t.newTag}</span>}
          </div>
          <p className="tool-card__desc">{description}</p>
          <span className="tool-card__link">{t.cardLink}</span>
        </div>
      </div>
    </Link>
  );
};

const Home = () => {
  const lang = useLang();
  const t = content[lang];
  const urlParams = new URLSearchParams(window.location.search);
  const hasLocalRankerAccess = urlParams.get("access") === "localranker";

  const tools = [...TOOLS, ...(hasLocalRankerAccess ? [ADVANCED_SEARCH] : [])].filter(
    (tool) => isLive(tool.routeId, lang),
  );

  return (
    <div className="home">
      <Seo routeId="home" title={t.seo.title} description={t.seo.description} />

      <Hero
        badge={t.hero.badge}
        title={t.hero.title}
        subtitle={t.hero.subtitle}
        ctaText={t.hero.cta}
        ctaHref={demoUrl(lang, "home")}
        compact
      />

      <section className="tools-section">
        <div className="tools-section__inner">
          <div className="tools-grid">
            {tools.map((tool) => (
              <ToolCard key={tool.routeId} tool={tool} lang={lang} t={t} />
            ))}
          </div>
        </div>
      </section>

      <section className="mission-section">
        <div className="mission-section__inner">
          <span className="mission-section__badge">{t.mission.badge}</span>
          <h2 className="mission-section__title">{t.mission.title}</h2>

          <div className="mission-section__grid">
            {t.mission.blocks.map((block) => (
              <div className="mission-section__block" key={block.title}>
                <h3>{block.title}</h3>
                <p>{block.text}</p>
              </div>
            ))}
          </div>

          <div className="mission-section__cta-wrap">
            <a
              className="mission-section__cta"
              href={demoUrl(lang, "home-mission")}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.mission.cta}
            </a>
          </div>
        </div>
      </section>

      <PageFooter />
    </div>
  );
};

export default Home;
